export default __webpack_public_path__ + "static/media/August2020.6171be91.png";